import { render, staticRenderFns } from "./borrowerinformation.vue?vue&type=template&id=705d4f99&"
import script from "./borrowerinformation.vue?vue&type=script&lang=js&"
export * from "./borrowerinformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports